import React, { ComponentProps } from 'react';
import classNames from 'classnames/bind';
import { IconCloseRoundStroked, defineUrlIcon } from '@carnica/graphics';
import { withRenderFlag } from '@beef/react';

import styles from './styles.pcss';

const cn = classNames.bind(styles);

const Gift = defineUrlIcon({
  url: 'https://static.beeline.ru/upload/images/fub/gift_bucket.svg',
  multiColor: false,
  defaultSize: 68,
  ratio: 1.13,
});

const GiftSmall = defineUrlIcon({
  url: 'https://static.beeline.ru/upload/images/fub/gift_small.svg',
  multiColor: false,
  defaultSize: 32,
  ratio: 1,
});

const _GiftedListItem: React.FC<{
  baseClass?: string;
  handleIconCloseClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  hasTethering?: boolean;
  rest: number;
}> = ({ rest, baseClass, children, handleIconCloseClick, hasTethering = false }) => {
  const IconGift = hasTethering ? GiftSmall : Gift;
  return (
    <li
      className={cn(baseClass, { extended: rest > 0, low: rest === 0 }, { inline: hasTethering })}
    >
      {children}
      {rest > 0 && <IconGift className={cn('gift')} />}
      {rest === 0 && (
        <IconCloseRoundStroked
          className={cn('close')}
          color="tertiary"
          onClick={handleIconCloseClick}
        />
      )}
    </li>
  );
};

export const GiftedListItem: React.FC<
  { shouldRender: boolean } & ComponentProps<typeof _GiftedListItem>
> = withRenderFlag(_GiftedListItem);
